export default __webpack_public_path__ + "static/media/team7.b7edce53.png";